'use strict';

const countries = require('i18n-iso-countries');

const localeEn = require('i18n-iso-countries/langs/en.json');

countries.registerLocale(localeEn);

const countryCodes = countries.getNames('en');

module.exports = countryCodes;
